import React, { useContext, useState } from "react";
import "./Need_advice.css";
import { Button, Form } from "react-bootstrap";
import Blue_btn from "../../common_components/common_btn/blue_btn/Blue_btn";
import { useNavigate } from "react-router-dom";

import { CreateNeedAdvice } from "../../features/need_advice/slice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import successAnimation from "../../animation/success_lottie/Success_lottie.json";
import Success_modal from "../../common_components/common_modal/success_modal/Success_modal";
import classNames from "classnames";
import { Context } from "../../../utils/context";

function Need_advice({ imgSrc }) {
  const [modalSuccessShow, setModalSuccessShow] = useState(false);
  const { language } = useContext(Context);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("email", data.email);
      formData.append("message", data.message);

      const res = await dispatch(CreateNeedAdvice(formData));

      if (res?.meta?.requestStatus === "fulfilled") {
        setModalSuccessShow(true);
        reset();
        setTimeout(() => setModalSuccessShow(false), 3000);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const navigate = useNavigate();
  return (
    <>
      <section className="Need_advice">
        <div className="container">
          <div className="row">
            <div className="col-md-6 order-md-1 order-2">
              <div className="heading_text_holder">
                <h2>
                  {language == 1 ? "Need Advice?" : "Besoin de conseils ?"}
                </h2>

                <p>
                  {language == 1 ? (
                    <>
                      Feeling unsure about where to start? <br /> Our advisors
                      are here to help.
                    </>
                  ) : (
                    <>
                      Vous ne savez pas par où commencer ? <br /> Nos
                      conseillers sont là pour vous aider.
                    </>
                  )}
                </p>
              </div>
              <div className="form_holder">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Form.Group className="form_field mb-3 ">
                    <Form.Label>{language == 1 ? "Name" : "Nom"}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={
                        language == 1 ? "Enter your Name" : "Entrez votre nom"
                      }
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      {...register("name", {
                        required:
                          language == 1
                            ? "Name is required"
                            : "Le nom est requis",
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                  </Form.Group>

                  <Form.Group className="form_field mb-3">
                    <Form.Label>
                      {language == 1 ? "Email" : "E-mail"}
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder={
                        language == 1
                          ? "Enter your email"
                          : "Entrez votre e-mail"
                      }
                      {...register("email", {
                        required:
                          language == 1
                            ? "Email is required"
                            : "L'e-mail est requis",
                        pattern: {
                          value: /^\S+@\S+$/i,
                          message:
                            language == 1
                              ? "Invalid email address"
                              : "Adresse e-mail invalide",
                        },
                      })}
                    />
                    {errors?.email && (
                      <Form.Text className="text-danger">
                        {errors?.email?.message}
                      </Form.Text>
                    )}
                  </Form.Group>

                  <Form.Group className="form_field mb-3">
                    <Form.Label>
                      {language == 1 ? "Message" : "Message"}
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder={
                        language == 1
                          ? "Enter your message"
                          : "Entrez votre message"
                      }
                      className={classNames({
                        "is-invalid": errors?.message,
                      })}
                      {...register("message", {
                        required:
                          language == 1
                            ? "Message is required"
                            : "Le message est requis",
                      })}
                    />
                    {errors?.message && (
                      <Form.Text className="text-danger">
                        {errors.message.message}
                      </Form.Text>
                    )}
                  </Form.Group>

                  <Blue_btn
                    btn_text={language == 1 ? "Get In Touch" : "Nous contacter"}
                    type="submit"
                  />
                </Form>
              </div>
            </div>

            <div className="col-md-6 order-md-2 order-1">
              <div className="img_holder">
                <img src={imgSrc} alt="section img" className="section_img" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalSuccessShow(false)}
        message_text={"Submit Successfull"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Need_advice;
